import * as api from '../../api/api-implicado-client';
import { 
    GET_GRILLA_IMPLICADO,
    GET_DATOS_PANTALLA,
    GET_COMBO_SEGURO,
    GET_COMBO_COMPANIAS,
    GET_COMBO_VEHICULOS,
    GET_COMBO_MARCAS,
    GET_COMBO_PAIS,
    GET_COMBO_COMUNAS,
    POST_ACTUALIZAR_IMPLICADO,
    PUT_ADICIONAR_IMPLICADO,
    OBTENER_DATOS_NO_FORMATOS,
    OBTENER_RUT_CONDUCTOR,
    OBTENER_RUT_PROPIETARIO,
    OBTENER_RUT_DESTINATARIO,
    GET_PARAMETROS,
    GET_CONFIG_FORM37,
    GET_COMBO_DESTINATARIO,
    GET_COMBO_MEDIO_PAGO,
    GET_COMBO_INSTITUCION,
    GET_COMBO_TIPO_CUENTA,
    GET_COMBO_TIPO_INVOLUCRADO,
    GET_COMBO_LESIONADO,
    GET_COMBO_GESTION,
 
} from '../types';

export const obtenerGrillaImplicado = (query) => ({
    type: GET_GRILLA_IMPLICADO,
    payload: api.getGrillaImplicado(query)
});
export const obtenerFormulario37 = (query) => ({
    type: GET_CONFIG_FORM37,
    payload: api.getConfiguracionForm37(query)
});
export const obtenerParametros = (query) => ({
    type: GET_PARAMETROS,
    payload: api.getParametrosFecha(query)
});
export const obtenerDatosPantalla = (query) => ({
    type: GET_DATOS_PANTALLA,
    payload: api.getDatosPantalla(query)
});
export const obtenerComboSeguro = (query) => ({
    type: GET_COMBO_SEGURO,
    payload: api.getComboSeguro(query)
});
export const obtenerComboCompanias = (query) => ({
    type: GET_COMBO_COMPANIAS,
    payload: api.getComboCompanias(query)
});
export const obtenerComboVehiculos = (query) => ({
    type: GET_COMBO_VEHICULOS,
    payload: api.getComboTipoVehiculo(query)
});
export const obtenerComboMarcas = (query) => ({
    type: GET_COMBO_MARCAS,
    payload: api.getComboMarcas(query)
});
export const obtenerComboPais = (query) => ({
    type: GET_COMBO_PAIS,
    payload: api.getComboPais(query)
});
export const obtenerComboComunas = (query) => ({
    type: GET_COMBO_COMUNAS,
    payload: api.getComboComunas(query)
});
export const enviarActualizacionImplicado = (newImplicado) => ({
    type: POST_ACTUALIZAR_IMPLICADO,
    payload: api.actualizarImplicado(newImplicado)
});
export const enviarAdicionarImplicado = (newImplicado) => ({
    type: PUT_ADICIONAR_IMPLICADO,
    payload: api.adicionarImplicado(newImplicado)
});
export const obtenerDatosNoFormato = (datosNoformatos) => ({
    type: OBTENER_DATOS_NO_FORMATOS,
    payload: datosNoformatos
});
export const obtenerRutConductor = (rut) => ({
    type:OBTENER_RUT_CONDUCTOR,
    payload: rut
});
export const obtenerRutPropietario = (rut) => ({
    type:OBTENER_RUT_PROPIETARIO,
    payload: rut
});
export const obtenerRutDestinatario = (rut) => ({
    type:OBTENER_RUT_DESTINATARIO,
    payload: rut
});
export const obtenerComboDestinatario = (query) => ({
    type: GET_COMBO_DESTINATARIO,
    payload: api.getComboDestinatario(query)
});
export const obtenerComboMedioPago = (query) => ({
    type: GET_COMBO_MEDIO_PAGO,
    payload: api.getComboMedioPago(query)
});
export const obtenerComboInstitucion = (query) => ({
    type: GET_COMBO_INSTITUCION,
    payload: api.getComboInstitucionFinanciera(query)
});
export const obtenerComboTipoCuenta = (query) => ({
    type: GET_COMBO_TIPO_CUENTA,
    payload: api.getComboTipoCuenta(query)
});
export const obtenerComboTipoInvolucrado = (query) => ({
    type: GET_COMBO_TIPO_INVOLUCRADO,
    payload: api.getComboTipoInvolucrado(query)
});
export const obtenerComboLesionado = (query) => ({
    type: GET_COMBO_LESIONADO,
    payload: api.getComboLesionado(query)
});
export const obtenerComboGestion = (query) => ({
    type: GET_COMBO_GESTION,
    payload: api.getComboGestion(query)
});